import styled, { css } from 'styled-components';
import { CloseThin } from '@lt/components/icons-react/userflow';

export const CloseButton = styled(CloseThin)<{ $inMobileInput?: boolean }>`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  margin: 20px 8px;
  z-index: 101;

  ${({ $inMobileInput }) =>
    $inMobileInput &&
    css`
      width: 16px;
      height: 16px;
      z-index: 101;

      > path {
        stroke: #919499;
      }
    `}
`;
